import React, { useState, useEffect } from "react";
import "../../components/AddDepartment/AddDepartment.css";
import axios from "axios";

const AddDepartment = ({tokenStorage, openAddProfile, setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    Dept_ID: "",
    Department: "",
  
    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if any required field is empty
  if (!formData.Department) {
    console.error("Department name is required.");
    // You can show an error message to the user if needed
    return;
  }
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddDepartment`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
    
      // Optionally, reset the form
      setFormData({
        Dept_ID: "",
        Department: "",
        createdBy: "",
        is_active: "",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      
      <br />

      <div className="departmentDetail">
        <div className="department-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Department Name*</td>
            </tr>

            <tr>
              
              <td>
                <input
                  type="text"
                  name="Department"
                  value={formData.Department}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addDepartment-button">
          <button  type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add Department
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddDepartment;
